import { render, staticRenderFns } from "./AppCapturePhoto.vue?vue&type=template&id=ff3bec14&"
import script from "./AppCapturePhoto.vue?vue&type=script&lang=js&"
export * from "./AppCapturePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports